import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Card' })((theme) => ({
    root: {
        display: 'flex',
        padding: 40,
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 32,
        flex: '1 0 0',
        borderRadius: 24,
        background: 'transparent',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        transition: 'all 0.2s',
        textDecoration: 'none',
        position: 'relative',
        zIndex: 1,
        // Hack to avoid slow render of huge shadow
        '&:before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: 'transparent',
            boxShadow: '0 0 96px 0 #A44025',
            zIndex: -1,
            transition: 'all 0.2s',
            opacity: 0,
            borderRadius: 'inherit',
            backdropFilter: 'blur(40px)'
        },
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            padding: 16
        },
        '@media (hover: hover)': {
            '&:hover': {
                borderColor: '#FF8B61',
                background: 'rgba(255, 255, 255, 0.03)',
                '&:before': {
                    opacity: 1
                }
            }
        }
    },
    icon: {
        lineHeight: 0,
        width: 'auto',
        height: 'auto',
        '& > svg': {
            width: '100%',
            height: '100%'
        }
    },
    hint: {
        color: '#fff',
        fontSize: 18,
        fontWeight: 400,
        lineHeight: '160%'
    }
}));
